import {JobModel} from '../models';
import {BaseApi} from './base.api';

export class ProjectsApi extends BaseApi {
    public getProjectJobs(projectId: string, filter: any = {}) {
        return this.GET_RequestAsync<JobModel[]>(`${this.ApiUrl}/projects/${projectId}/jobs?filter=${encodeURIComponent(JSON.stringify(filter))}`);
    }
}
